import {
  useSMSManualScheduledWSSubscription,
  useSMSDataV3WSSubscription,
  useSMSPreferenceEventSubscription,
  useSMSTagNotificationSubscription,
  useInboxRobocallTagNotificationSubscription,
  useReviewEventSubscription,
  useFaxEventSubscription,
  useFaxCountEventSubscription,
  useFaxReadEventSubscription,
  useFaxTagEventSubscription,
  useNewBlockedFaxEventSubscription,
  useSMSWSSubscription,
  useSMSTaskWSSubscription,
  useInboxThreadItemWSSubscription,
  useInboxThreadItemTagWSSubscription,
  useThreadAiStateWSSubscription,
} from './hooks';

export const useAllMessagingWebsockets = () => {
  useSMSManualScheduledWSSubscription();
  useSMSDataV3WSSubscription();
  useInboxThreadItemWSSubscription();
  useSMSWSSubscription();
  useSMSPreferenceEventSubscription();
  useSMSTagNotificationSubscription();
  useInboxRobocallTagNotificationSubscription();
  useSMSTaskWSSubscription();
  useReviewEventSubscription();
  useFaxEventSubscription();
  useFaxTagEventSubscription();
  useFaxCountEventSubscription();
  useFaxReadEventSubscription();
  useNewBlockedFaxEventSubscription();
  useInboxThreadItemTagWSSubscription();
  useThreadAiStateWSSubscription();
};
